import { render } from "./EcomConfigEdit.vue?vue&type=template&id=5d84c5d8&scoped=true"
import script from "./EcomConfigEdit.vue?vue&type=script&lang=js"
export * from "./EcomConfigEdit.vue?vue&type=script&lang=js"

import "./EcomConfigEdit.vue?vue&type=style&index=0&id=5d84c5d8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d84c5d8"]])

export default __exports__